// TO DEFINE THE STATES AND CHANGE STATUS
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedReport: 0,
};

const reportsSlice = createSlice({
  name: 'reports',
  initialState,
  reducers: {
    setSelectedReport: (state, action) => {
      state.selectedReport = action.payload;
    },
  },
});

export const { setSelectedReport } = reportsSlice.actions;
export const selectSelectedReport = (state) => state.reports.selectedReport;

export default reportsSlice.reducer;
